import { render, staticRenderFns } from "./DebugWindow.vue?vue&type=template&id=13e69654&lang=pug&"
import script from "./DebugWindow.vue?vue&type=script&lang=js&"
export * from "./DebugWindow.vue?vue&type=script&lang=js&"
import style0 from "./DebugWindow.vue?vue&type=style&index=0&id=13e69654&prod&lang=sass&module=true&"
import style1 from "./DebugWindow.vue?vue&type=style&index=1&id=13e69654&prod&lang=sass&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports